import Stepper from 'components/cart-item-editor/Stepper';
import { useStores } from 'hooks/use-stores';
import orderBy from 'lodash/orderBy';
import { observer } from 'mobx-react';
import CartItemType from 'models/CartItem';
import { useEffect } from 'react';
import { notification } from 'top-component-library';
import ListItem from './GenericItemsList/ListItem';

function CartItem({ cartItem }: { cartItem: CartItemType }) {
  const { checkoutStore, menuDataStore } = useStores();
  const { menu_item_id, preDiscountPretaxCents, id, qty, pretaxCentsWithDiscount, hasBOGO } = cartItem;
  const menuItem = menuDataStore.menuItemsById[menu_item_id];
  const { selectedCart } = checkoutStore;
  const { isSharedCart } = selectedCart;
  const price = isSharedCart && hasBOGO ? pretaxCentsWithDiscount : preDiscountPretaxCents;

  const sortedGroups = orderBy(
    Object.keys(cartItem.mods).map((groupId) => menuDataStore.modifierGroupsById[groupId]),
    ['display_position', 'heading_name']
  );
  const visibleGroups = sortedGroups.filter((group) => !group?.integrations?.hide_from_guests ?? false);

  useEffect(() => {
    if (!menuDataStore.loaded || !Object.keys(menuDataStore.menuItemsById).length) {
      return;
    }

    const itemDoesNotExistErrorReason =
      (!menuItem || !cartItem.isFulfillable) && 'it is no longer offered at this location.';
    const menuDoesNotExistErrorReason =
      !menuDataStore.menus.some((menu) => menu.id === cartItem.menu_id) &&
      'the menu it belongs to is not offered at this location.';
    const shouldRemoveItemReason = itemDoesNotExistErrorReason || menuDoesNotExistErrorReason || '';

    if (shouldRemoveItemReason) {
      selectedCart.removeItem(cartItem);
      notification.error({
        key: cartItem.menu_item_id,
        message: `${
          cartItem.name_for_customer || 'An item'
        } has been removed from your cart because ${shouldRemoveItemReason}`,
      });
    }
  }, [
    menuDataStore.loaded,
    menuDataStore.menuItemsById,
    menuDataStore.menus,
    selectedCart,
    cartItem,
    cartItem.isFulfillable,
    menuItem,
  ]);

  return !menuItem ? null : (
    <ListItem
      item={{
        name: cartItem.name_for_customer || menuItem.name_for_customer,
        price,
        qty: cartItem.qty,
        mods: visibleGroups.flatMap((group) =>
          (cartItem.mods[group.id] ?? [])
            .filter((mod) => mod.selected)
            .map((mod) => ({ qty: mod.qty, name: mod.name, menu_item_id: mod.menu_item_id }))
        ),
        imageUrl: menuItem.imageUrl,
      }}
      priceAfterBOGO={cartItem?.priceAfterBOGO}
    >
      <Stepper
        itemId={id}
        itemInCart
        selectedCart={selectedCart}
        quantity={qty}
        setVisible={() => {}}
        fromCart
        adjustPadding
        existingCartItem={cartItem}
      />
    </ListItem>
  );
}

export default observer(CartItem);
